import { Link } from 'react-router-dom';
import SubpageShell from '@/components/feature/SubpageShell';

export default function NotFound() {
  return (
    <SubpageShell title="Page not found" description="The page you were looking for doesn't exist or has moved.">
      <section className="bg-background-50 pb-20 md:pb-28">
        <div className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-16 flex flex-wrap gap-x-8 gap-y-4">
          {[['Back to home', '/'], ['Services', '/services'], ['The Artists', '/artists'], ['Selected Work', '/work'], ['Visit', '/visit']].map(([label, to]) => (
            <Link key={to} to={to} className="inline-flex items-center gap-2 text-[14px] font-medium text-foreground-950 border-b border-foreground-950 pb-0.5 whitespace-nowrap cursor-pointer hover:text-foreground-600">
              {label} <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
            </Link>
          ))}
        </div>
      </section>
    </SubpageShell>
  );
}